import React from 'react';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { useLanguage } from '../context/LanguageContext';
import { FLAG_LIST, HOTEL_IMAGE_URL } from '../constants';
import { useNavigate } from 'react-router-dom';
import { useHotel } from '../context/HotelContext';

const LanguagePage = () => {
    const { langList, changeLanguage, lang } = useLanguage();
    const navigate = useNavigate();
    const { hotelDetails } = useHotel();

    const continueClickHandler = (language) => {
        changeLanguage(language);
        navigate('/');
    };
    const { t } = useLanguage();
    return (
        <div className='layout flex flex-1 px-4 w-full justify-center items-center  min-h-screen relative bg-gray-900'>
            <div className='flex flex-col justify-center items-center gap-4 w-full mb-8 max-w-80'>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTEL_IMAGE_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='w-56 h-20 mb-4 object-contain'
                    />
                )}
                <div className='text-white w-full text-left'>
                    Choose your language :{' '}
                </div>
                {langList.map((item) => (
                    <div
                        key={item.id}
                        className={
                            'flex justify-between items-center border px-4 w-full py-4 rounded-lg lang-card text-white ' +
                            (item.lang_code === lang
                                ? 'border bg-green-100 border-green-200 text-black'
                                : '')
                        }
                        onClick={() => continueClickHandler(item.lang_code)}
                    >
                        <span
                            className={
                                'flex justify-start items-center text-2xl gap-2 ' +
                                (item.lang_code === lang ? ' text-black' : '')
                            }
                        >
                            <span className='text-4xl font-semibold'>
                                {FLAG_LIST[item.lang_code.toUpperCase()]}{' '}
                            </span>
                            {item.lang_name}
                        </span>
                        {item.lang_code === lang && (
                            <span className='text-2xl'>
                                <CheckCircleTwoTone twoToneColor='green' />
                            </span>
                        )}
                    </div>
                ))}
                {/* <Button
                    type='primary'
                    size='large'
                    onClick={continueClickHandler}
                >
                    Continue
                </Button> */}
            </div>
            <div className='flex flex-col absolute bottom-4  w-full px-4 text-center justify-center items-center'>
                <div
                    className='flex flex-col font-normal text-xs text-gray-300'
                    dangerouslySetInnerHTML={{
                        __html: t['restaurant_disclaimer_msg_one'],
                    }}
                ></div>
            </div>
        </div>
    );
};

export default LanguagePage;
